import gamesData from "../../data/games.json";
import GameTile from "./GameTile";
import "./GameSelect.css";

export default function GameSelect({ onGameSelect }) {
  function handleGameSelect(game) {
    onGameSelect(game.id);
  }

  return (
    <main className="game-select">
      <header className="game-select__header">
        <img
          src="/games/TacMaps_Logo.png"
          alt="TacMaps"
          className="game-select__logo"
          width="100px"
        />
        <p className="game-select__eyebrow">
          TACMAPS
        </p>
      </header>

      <section
        className="game-grid"
        aria-label="Available games"
      >
        {gamesData.games.map((game) => (
          <GameTile
            key={game.id}
            game={game}
            onSelect={handleGameSelect}
          />
        ))}
      </section>

      <footer className="game-select__footer">
        <a
          className="game-select__social-link"
          href="https://x.com/tacmapsgg"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TacMaps on X"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            focusable="false"
          >
            <path d="M23.953 4.57a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723 9.99 9.99 0 0 1-3.127 1.195 4.92 4.92 0 0 0-8.384 4.482A13.98 13.98 0 0 1 1.64 3.162a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.06c0 2.386 1.697 4.374 3.95 4.827a4.936 4.936 0 0 1-2.224.084c.63 1.956 2.445 3.377 4.6 3.417A9.9 9.9 0 0 1 0 19.54a13.94 13.94 0 0 0 7.548 2.212c9.057 0 14.01-7.503 14.01-14.01 0-.213-.005-.425-.014-.636A10.012 10.012 0 0 0 24 4.59z" />
          </svg>
        </a>
      </footer>
    </main>
  );
}